import React, { useState, FunctionComponent, useEffect, useRef } from 'react';
import { Presentation } from './presentation';

type Props = {
  onChangedBody: (name: string, value: string) => void;
  target: 'tel' | 'instagram' | 'twitter';
  body: string;
  motivation: string;
  isModal: boolean;
};

export const Component: FunctionComponent<Props> = ({
  onChangedBody,
  target,
  body: initialBody,
  motivation,
  isModal,
}) => {
  const [body, setBody] = useState<string>('');
  const prevProps = useRef<{ body: string; target: string; isModal: boolean }>({
    body: initialBody,
    target,
    isModal,
  });

  useEffect(() => {
    setBody(initialBody);
  }, []);

  useEffect(() => {
    const prev = prevProps.current;
    if (prev.body !== initialBody) {
      setBody(initialBody);
    }
    if (prev.isModal !== isModal && prev.target !== target) {
      setBody('');
    }
    prevProps.current = { body: initialBody, target, isModal };
  }, [initialBody, target, isModal]);

  const handleChange = (name: string, value: string) => {
    setBody(value);
    const formatted = formatFinalValue(value);
    if (formatted !== value) {
      setTimeout(() => {
        setBody(formatted);
        onChangedBody(target, formatted);
      }, 0);
    } else {
      onChangedBody(target, formatted);
    }
  };

  const formatFinalValue = (value: string): string => {
    if (target === 'instagram' || target === 'twitter') {
      return value.replace(/\s+/g, '').replace(/[^a-zA-Z0-9_.]/g, '');
    }
    if (target === 'tel') {
      const normalize = (str: string) => str
        .replace(/[０-９]/g, c => String.fromCharCode(c.charCodeAt(0) - 0xfee0)) // 全角数字 → 半角
        .replace(/[ー−―‐]/g, '-'); // 全角ハイフンっぽい文字をすべて半角ハイフンへ
      const normalized = normalize(value);
      // 半角数字と半角ハイフン以外を削除
      return normalized.replace(/[^\d-]/g, '');
    }
    return value;
  };

  return (
    <Presentation
      body={body}
      target={target}
      onChangeBody={handleChange}
     />
  );
};
